exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.add-technician-field .select-wrapper[data-v-e6ef856e]{display:flex;justify-content:space-between;align-items:center;gap:20px\n}\n.add-technician-field .select-wrapper .v-select[data-v-e6ef856e]{flex-grow:1\n}\n.add-technician-field .select-wrapper .md-icon-button[data-v-e6ef856e]{border-radius:50%;padding:10px;margin:0\n}", ""]);

// exports
